/**
 * Breadcrumbs are rendered inside ComponentHeaderTwo (purple page header).
 * This component is kept as a no-op so existing layout imports stay valid.
 */
export default function PageBreadcrumbs() {
  return null;
}
